import api from './apiconfig.js';

/**
 * Waiter API Service
 * Handles waiter management operations
 */

const API_BASE_URL = api.API_BASE; // Update with your backend URL

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` })
  };
};

const handleResponse = async (response) => {
  if (!response.ok) {
    const error = await response.json().catch(() => ({ message: 'Network error' }));
    throw new Error(error.message || `HTTP ${response.status}`);
  }
  return response.json();
};

export const getWaiters = async () => {
  const response = await fetch(`${API_BASE_URL}/waiters`, {
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const getWaiterById = async (waiterId) => {
  const response = await fetch(`${API_BASE_URL}/waiters/${waiterId}`, {
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const createWaiter = async (waiterData) => {
  const response = await fetch(`${API_BASE_URL}/waiters`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(waiterData)
  });
  const data = await handleResponse(response);
  return data;
};

export const updateWaiter = async (waiterId, waiterData) => {
  const response = await fetch(`${API_BASE_URL}/waiters/${waiterId}`, {
    method: 'PUT',
    headers: getAuthHeaders(),
    body: JSON.stringify(waiterData)
  });
  const data = await handleResponse(response);
  return data;
};

export const deleteWaiter = async (waiterId) => {
  const response = await fetch(`${API_BASE_URL}/waiters/${waiterId}`, {
    method: 'DELETE',
    headers: getAuthHeaders()
  });
  const data = await handleResponse(response);
  return data;
};

export const getWaiterCommissions = async ({ orderId, businessDate, waiterId, waiterName, groupBy } = {}) => {
  const params = new URLSearchParams();
  if (orderId) params.append('order_id', orderId);
  if (businessDate) params.append('business_date', businessDate);
  if (waiterId) params.append('waiter_id', waiterId);
  if (waiterName) params.append('waiter_name', waiterName);
  if (groupBy) params.append('group_by', groupBy);

  const response = await fetch(`${API_BASE_URL}/waiters/commissions${params.toString() ? `?${params.toString()}` : ''}`, {
    headers: getAuthHeaders()
  });
  return handleResponse(response);
};

export const createWaiterCommission = async (commissionData) => {
  const response = await fetch(`${API_BASE_URL}/waiters/commissions`, {
    method: 'POST',
    headers: getAuthHeaders(),
    body: JSON.stringify(commissionData)
  });
  return handleResponse(response);
};